/* Slide switch sized to sit comfortably in a header or alongside the
   segmented Toggle. The icon lives in the knob. */
.toggle {
	position: relative;
	flex: none;
	width: 60px;
	/* Matches the height of the segmented Toggle (mode switch) so the two line
	   up when they share a header row. */
	height: var(--control-h);
	border-radius: 999px;
	background: var(--surface-input);
	border: 1px solid var(--border);
	padding: 0;
	cursor: pointer;
	transition:
		background 120ms ease,
		border-color 120ms ease;
}

.on {
	background: var(--accent-sage);
	border-color: var(--accent-sage);
}

.knob {
	position: absolute;
	top: 50%;
	left: 3px;
	width: 33px;
	height: 33px;
	border-radius: 50%;
	background: #fff;
	box-shadow: var(--shadow-card);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transform: translateY(-50%);
	transition: transform 120ms ease;
}

.on .knob {
	transform: translate(21px, -50%);
}

.icon {
	color: var(--ink-muted);
}

.on .icon {
	color: var(--accent-sunshine);
}
